module.exports = __webpack_public_path__ + "img/aws-s3.ee77d41e.svg";